module.exports = __webpack_public_path__ + "img/saas_3.ae6a30e5.png";